// extracted by mini-css-extract-plugin
export default {"wrap":"wrap-ScMw","isDropping":"isDropping-T_ol"};